import { render, staticRenderFns } from "./a-back-to-top.vue?vue&type=template&id=64c74420&scoped=true&"
import script from "./a-back-to-top.vue?vue&type=script&lang=js&"
export * from "./a-back-to-top.vue?vue&type=script&lang=js&"
import style0 from "./a-back-to-top.vue?vue&type=style&index=0&id=64c74420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c74420",
  null
  
)

export default component.exports